import {httpConstants} from "../constants";
import {httpService} from "../utility/httpService";

export default {
    getReferralList,
    addReferral,
    getReferredUserList
}

async function addReferral(req) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.REFERRAL;
    return httpService(httpConstants.METHOD_TYPE.POST, getHeaders(), req, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}

async function getReferralList(requestData) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.REFERRAL_LIST;
    return httpService(httpConstants.METHOD_TYPE.GET, getHeaders(), requestData, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}

async function getReferredUserList(id) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.REFERRED_USER_LIST + `?id=${id}`;
    return httpService(httpConstants.METHOD_TYPE.GET, getHeaders(), {}, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}

function getHeaders() {
    return {'Content-Type': httpConstants.CONTENT_TYPE.APPLICATION_JSON, 'skip': true}
}
